function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.85 2.207l.476-.476a3.061 3.061 0 014.33 4.33L5.85 10.865 1.044 6.06a3.061 3.061 0 014.33-4.33l.476.477z",
  fill: "inherit",
  stroke: "currentColor",
  strokeWidth: "inherit",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

function SvgHeartUltrathin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.7 11.7"
  }, props), _ref);
}

export default SvgHeartUltrathin;